<template>
    <div />
</template>

<script>
    import {toRaw} from "vue";
    import {setMercator, setOriginProjection} from "../../utils/tbUtils";

    // 根据线数据列表，画出多条三维线，存放在一个layer中
    export default {
        name: "Line3d",
        props: {
            lines:{
                required: true // 线数据列表，需要geoJson: FutureCollection<Future<LineString>>
            },
            map:{
                required: true // mapbox对象
            },
            tb:{
                required: true // threebox对象
            },
            lineColor:{
                required: false, // 画线颜色，默认白色
                default: '#FFFFFF'
            },
            lineWidth:{
                required: false, // 画线宽度，默认1
                default: 1
            },
            lineOpacity:{
                required: false, // 画线不透明度，默认1
                default: 1
            }
        },
        data(){
            return{
                id:'',
                lineMeshList: [],
            }
        },
        methods:{
            setLine3d(){
                const _this = this;

                // 添加threebox自定义图层 3D线集合
                this.map.addLayer({
                    id: this.id,
                    type: 'custom',
                    renderingMode: '3d',

                    onAdd(map, gl){
                        // 每一组线数据画一条三维线
                        for(let i=0; i < _this.lines.length; ++i){

                            // 画一条三维线
                            const linePoints = _this.lines[i];
                            const lineOptions = {
                                geometry: linePoints,
                                color: _this.lineColor,
                                width: _this.lineWidth,
                                opacity: _this.lineOpacity
                            }

                            const lineMesh = _this.tb.line(lineOptions);
                            _this.lineMeshList.push(lineMesh);

                            _this.tb.add(toRaw(lineMesh));
                        }
                    },
                    render(gl, matrix){
                        _this.tb.update();
                    }
                });
            },
            removeLine3d(){
                for(let i=0; i < this.lineMeshList.length; ++i){
                    const lineMesh = this.lineMeshList[i];
                    this.tb.remove(toRaw(lineMesh));
                }
                this.map.removeLayer(this.id);
            }
        },
        mounted() {
            this.id = 'line3d-' + Math.random().toString(36);
            setMercator(this.map, this.id);

            // 设置三维线
            this.setLine3d();
        },
        destroyed() {
            // 移除三维数据自定义图层，释放资源
            this.removeLine3d();
            setOriginProjection(this.map, this.id);
        }
    }
</script>

<style scoped>

</style>
